module.exports = __webpack_public_path__ + "static/media/sound-phone-vibration.ba228e06.mp3";